<template>
  <div class="searching-lists">
    <div v-if="providers.length" class="searching-lists__item" data-headline="providers">
      <ProvidersList :list="providers" />
    </div>

    <div v-if="games.length" class="searching-lists__item">
      <SearchHeadline
        v-if="providers.length"
        :title="$t('lobby.search.titleGames')"
        :text="$t('lobby.search.textResult', { value: searchValue })"
        class="searching-lists__title"
      />

      <GamesList :list="games" />
    </div>
  </div>
</template>

<script>
import GamesList from '~/components/Lobby/SearchModal/components/GamesList'
import ProvidersList from '~/components/Lobby/SearchModal/components/ProvidersList'
import SearchHeadline from '~/components/Lobby/SearchModal/components/SearchHeadline'

export default {
  name: 'SearchingLists',
  components: {
    ProvidersList,
    GamesList,
    SearchHeadline,
  },
  props: {
    providers: { type: Array },
    games: { type: Array },
    searchValue: { type: String },
  },
  mounted() {
    this.$nextTick(() => {
      this.$emit('onMountResult')
    })
  },
}
</script>

<style scoped lang="scss">
.searching-lists {
  padding: var(--spaces-l) var(--padding-xl) var(--spaces-s) var(--padding-xl);

  @include media (tablet-album) {
    padding: 0;
  }

  &__item {
    &:not(:last-child) {
      margin-bottom: var(--spaces-l);

      @include media (tablet-album) {
        margin-bottom: var(--spaces-xl);
      }
    }
  }

  &__title {
    margin-bottom: var(--spaces-s);

    @include media (tablet-album) {
      margin-bottom: var(--spaces-xl);
    }
  }
}
</style>
